module.exports = __webpack_public_path__ + "static/media/edit.586ae88c.svg";